import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {ErrorMessage, Field, Form, Formik} from 'formik';
/* Components */
import Input from '../../../common/form-elements/input/input';
import FormErrorMessage from '../../../common/form-elements/form-error-message/form-error-message';
/* Helpers */
import {
  maxLength,
  minLength,
  required,
  schemaValidate,
  urlChecker,
} from '../../../../helpers/validation-helpers';
import {AUTO_REFRESH_OPTIONS} from '../widget-constants';

class WebPageForm extends React.PureComponent {
  handleSelectOptionChange = (field, props) => (value) => {
    return props.setFieldValue(field, value);
  };

  render() {
    return (
      <Formik initialValues={this.props.initialValues} onSubmit={this.props.onFormSubmit}>
        {(props) => {
          return (
            <Form>
              <div className="glu-modal__body">
                <div className="glu-content__section">
                  <div className="glu-form-row">
                    <div className="glu-label">Widget Title</div>
                    <Field
                      as={Input}
                      autoFocus
                      name="title"
                      className="glu-form-input-pad"
                      onChange={props.handleChange('title')}
                      validate={schemaValidate([required(), minLength(), maxLength(30)])}
                      invalid={props.errors.title && props.touched.title}
                    />
                    <ErrorMessage name="title" component={FormErrorMessage} />
                  </div>
                  <div className="glu-form-row">
                    <div className="glu-label">Auto Refresh</div>
                    <Field
                      as={Select}
                      name="autoRefresh"
                      options={AUTO_REFRESH_OPTIONS}
                      isSearchable={false}
                      value={props.values.config.autoRefresh || AUTO_REFRESH_OPTIONS[0]}
                      onChange={this.handleSelectOptionChange('config.autoRefresh', props)}
                      className="glu-select glu-form-input-pad"
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div className="glu-form-row">
                    <div className="glu-label">Source URL</div>
                    <Field
                      className="glu-flex-grow glu-form-input-pad"
                      as={Input}
                      name="url"
                      onChange={props.handleChange('url')}
                      validate={schemaValidate([required(), urlChecker()])}
                      invalid={props.errors.url && props.touched.url}
                      placeholder="https://"
                    />

                    <ErrorMessage name="url" component={FormErrorMessage} />
                  </div>
                  <div className="glu-flex glu-web-widget__disclaimer">
                    <span className="g-icon g-icon-info" />
                    <span className="text-secondary glu-web-widget__disclaimer_text">
                      Be aware that some websites might not allow their content to be embedded in a
                      widget
                    </span>
                  </div>
                </div>
              </div>
              <footer className="glu-modal__footer">
                <div className="glu-flex-grow glu-flex-row">
                  <div className="glu-flex-grow text-right">
                    <button
                      onClick={this.props.onCancel}
                      className="glu-btn glu-btn--secondary"
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="glu-flex-shrink">
                    <button type="submit" className="glu-btn glu-btn--primary">
                      Save
                    </button>
                  </div>
                </div>
              </footer>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

WebPageForm.propTypes = {
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default WebPageForm;
